// extracted by mini-css-extract-plugin
module.exports = {"primary":"m_z","secondary":"m_B"};